import { mutatorAction } from "satcheljs";
import { getStore } from "../store/store";
import type { TeamsSDKState } from "../store/schema/TeamsClientState";

/**
 * Set the TeamsSDKState in the theme creator store
 * @param state the TeamsSDKState to set
 */
const setSdkStateMutator: (state: TeamsSDKState) => void = mutatorAction("setTeamsSdkState", (state: TeamsSDKState): void => {
    getStore().sdkState = state;
});

export default setSdkStateMutator;
